// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavSuggestions_nav-suggestions__R\\+PQl {
  height: 100%;
}

.NavSuggestions_nav-suggestions__btn__PWdRq {
  display: flex;
  align-items: center;
  gap: 2rem;
  padding-inline: 6rem;
  height: 100%;
}

.NavSuggestions_nav-suggestions__text__0bqKW {
  font-size: var(--text-base);
  font-weight: 500;
  color: #fff;
}

.NavSuggestions_nav-suggestions--active__-OyFK {
  background-color: #fff;
}

.NavSuggestions_nav-suggestions--active__-OyFK .NavSuggestions_nav-suggestions__text__0bqKW {
  color: var(--primary-color);
}

.NavSuggestions_nav-suggestions__R\\+PQl svg {
  width: 2rem;
  height: 2rem;
}

.NavSuggestions_nav-suggestions--active__-OyFK svg > path {
  stroke: var(--primary-color);
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .NavSuggestions_nav-suggestions__btn__PWdRq {
    padding-inline: 2rem;
    gap: 1rem;
  }

  .NavSuggestions_nav-suggestions__text__0bqKW {
    font-size: var(--text-sm);
  }

  .NavSuggestions_nav-suggestions__R\\+PQl svg {
    width: 1.6rem;
    height: 1.6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardHeader/Navbar/NavSuggestions/NavSuggestions.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF","sourcesContent":[".nav-suggestions {\n  height: 100%;\n}\n\n.nav-suggestions__btn {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  padding-inline: 6rem;\n  height: 100%;\n}\n\n.nav-suggestions__text {\n  font-size: var(--text-base);\n  font-weight: 500;\n  color: #fff;\n}\n\n.nav-suggestions--active {\n  background-color: #fff;\n}\n\n.nav-suggestions--active .nav-suggestions__text {\n  color: var(--primary-color);\n}\n\n.nav-suggestions svg {\n  width: 2rem;\n  height: 2rem;\n}\n\n.nav-suggestions--active svg > path {\n  stroke: var(--primary-color);\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .nav-suggestions__btn {\n    padding-inline: 2rem;\n    gap: 1rem;\n  }\n\n  .nav-suggestions__text {\n    font-size: var(--text-sm);\n  }\n\n  .nav-suggestions svg {\n    width: 1.6rem;\n    height: 1.6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav-suggestions": `NavSuggestions_nav-suggestions__R+PQl`,
	"nav-suggestions__btn": `NavSuggestions_nav-suggestions__btn__PWdRq`,
	"nav-suggestions__text": `NavSuggestions_nav-suggestions__text__0bqKW`,
	"nav-suggestions--active": `NavSuggestions_nav-suggestions--active__-OyFK`
};
export default ___CSS_LOADER_EXPORT___;
